/**
 * Get theme-based CSS values based on the theme path
 * @example
 * themeGet('fontSize.small') // => `var(--t-fontSize-small)`
 */
export function themeGet(path) {
    return `var(--t-${path.replaceAll('.', '-')})`;
}
/**
 *
 * @param colorPath The colors path. Example: `'gray.100'`
 * @param opacity Adds opacity to the color. Example: `0.5`
 * @returns The selected color with the added opacity
 */
export function themeGetColor(colorPath, opacity) {
    const themePath = `colors.${colorPath}`;
    if (opacity === undefined) {
        return themeGet(themePath);
    }
    if (__DEV__) {
        if (opacity < 0 || opacity > 1) {
            // eslint-disable-next-line no-console
            console.warn('The `opacity` in `themeGetColor` function must be a number between 0 and 1');
        }
    }
    return `color-mix(in srgb, ${themeGet(themePath)}, transparent ${(1 - opacity) * 100}%)`;
}
